export default function getUser(state = {}, action) {
    const amount = sessionStorage.getItem("shippng_amount")
    switch (action.type) {
        case "USER_DETAIL":
            return { user:{... action.value,shipping_amount:amount} };
        default:
            return state;
    }
}
